import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { Button } from "@biome-design-system/ui/Button";
import { Stack } from "@biome-design-system/ui/Stack";
import { useFilterWizardContext } from "./FilterWizardContext.js";
import { getShowSkip } from "./utils.js";
const DEFAULT_BACK_LABEL = "Back";
const DEFAULT_SKIP_LABEL = "Skip";
const WizardNavigation = styled(Stack, {
  name: "MuiFilterWizard",
  slot: "navigation"
})(() => ({}));
const Navigation = ({
  navigation,
  labels: {
    back: labelBack = DEFAULT_BACK_LABEL,
    skip: labelSkip = DEFAULT_SKIP_LABEL
  } = {},
  hideSkip = false,
  showSkipOnFirstStepOnly = false
}) => {
  const {
    canGoBack,
    completed,
    currentStep,
    handleBack,
    handleExit,
    progress
  } = useFilterWizardContext();
  let content;
  if (typeof navigation === "function") {
    content = navigation({
      canGoBack,
      completed,
      handleBack,
      handleExit,
      progress
    });
  } else {
    const showSkip = getShowSkip(
      hideSkip,
      showSkipOnFirstStepOnly,
      currentStep,
      completed
    );
    content = /* @__PURE__ */ jsxs(Fragment, { children: [
      Boolean(canGoBack) && /* @__PURE__ */ jsx(
        Button,
        {
          "data-testid": "filter-wizard-back-button",
          onClick: handleBack,
          variant: "outlined",
          children: labelBack
        }
      ),
      Boolean(showSkip) && /* @__PURE__ */ jsx(
        Button,
        {
          "data-testid": "filter-wizard-skip-button",
          onClick: handleExit,
          variant: "text",
          children: labelSkip
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsx(
    WizardNavigation,
    {
      direction: "row",
      spacing: 2,
      sx: {
        alignItems: "center",
        justifyContent: "flex-start"
      },
      children: content
    }
  );
};
export {
  Navigation
};
